<template>
   <div class="hint">
      <div class="infoBox">
         <p class="title">标识检验示意图</p>
         <ul>
            <li>
               <p class="name">检验步骤1</p>
               <p class="describe">用水性笔涂写并抹开后，会显示“ <img class="icon" src="../assets/images/hint_icon.png"> ”有色图案。</p>
               <p class="displayImg">
                  <img class="img" src="../assets/images/img1.png">
               </p>
            </li>
            <li>
               <p class="name">检验步骤2</p>
               <p class="describe">揭开表面薄膜层后，可见印刷层遗留下透印的“ <img class="icon" src="../assets/images/hint_icon.png"> ”有色痕迹。</p>
               <p class="displayImg">
                  <img class="img" src="../assets/images/img2.png">
               </p>
            </li>
            <li>
               <p class="name">检验步骤3</p>
               <p class="describe">印刷膜遗留下透印的“ <img class="icon" src="../assets/images/hint_icon.png"> ”有色痕迹，痕迹可抹去。</p>
               <p class="displayImg">
                  <img class="img" src="../assets/images/img3.png">
               </p>
            </li>
            <li>
               <p class="name">检验步骤4</p>
               <p class="describe">揭开标识后，被贴物上遗留加密图案。</p>
               <p class="displayImg">
                  <img class="img" src="../assets/images/img4.png">
               </p>
            </li>
         </ul>
      </div>
   </div>
</template>

<script>
   export default {
      data() {
         return {

         }
      }
   }
</script>

<style lang="less" scoped>
   .hint {
      padding: 16px 12px 25px;
      .infoBox {
         border-radius: 12px;
         background-color: #FFF;
         .title {
            line-height: 30px;
            font-size: 21px;
            font-weight: bold;
            color: #CF3139;
            padding: 24px 0;
            text-align: center;
            border-bottom: 1px solid rgba(237, 237, 237, .6);
         }
         ul {
            padding: 24px 0 0 16px ;
            li {
               color: #333;
               padding-bottom: 32px;
               .name {
                  line-height: 23px;
                  font-size: 16px;
                  font-weight: bold;
                  &::before {
                     content: "";
                     width: 7px;
                     height: 7px;
                     display: inline-block;
                     border: 3px solid #CF3139;
                     border-radius: 50%;
                     margin-right: 5px;
                  }
               }
               .describe {
                  word-break:break-all;
                  padding-right: 32px;
                  line-height: 24px;
                  font-size: 16px;
                  margin-top: 6px;
                  .icon {
                     width: 41px;
                  }
               }
               .displayImg {
                  margin-top: 12px;
                  padding-right: 16px;
                  text-align: center;
                  .img {
                     box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.05);
                     width: 300px;
                  }
               }
            }
         }
      }
   }
</style>